export const firebaseConfig = {
  apiKey: 'AIzaSyDM1n2fxWYteJ_nqvnfrS4SpvlHCtKdADo',
  authDomain: 'docok-20335.firebaseapp.com',
  projectId: 'docok-20335',
  storageBucket: 'docok-20335.firebasestorage.app',
  messagingSenderId: '577133838099',
  appId: '1:577133838099:web:022065cea92bf1cc0324e6',
  measurementId: 'G-C5H2L43627',
}
